import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LineRoutingModule } from './line-routing.module';
import { LineComponent } from './line.component';
import { FormComponent } from './form/form.component';
import { ConfirmOtpComponent } from './confirm-otp/confirm-otp.component';
import { MobileListComponent } from './mobile-list/mobile-list.component';
import { CompletedComponent } from './completed/completed.component';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { NgOtpInputModule } from 'ng-otp-input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { ModalModule } from 'src/app/shared/service/modal/modal.module';
import { NewUserComponent } from './new-user/new-user.component';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { FormVerifyCustomerService } from './services/form-verify-customer.service';
import { ConcentService } from './services/concent.service';
import { LoaderComponent } from './loader/loader.component';
import { LoaderService } from './services/loader.service';
import { LineConfirmComponent } from './line-confirm/line-confirm.component';
import { MobileVerifyComponent } from './mobile-verify/mobile-verify.component';
import { LineStateActionService } from './statemanagement/line-state-action.service';
import { TermAndConditionComponent } from './term-and-condition/term-and-condition.component';
import { Route1Component } from './route1/route1.component';
import { Route2Component } from './route2/route2.component';
import { Route3Component } from './route3/route3.component';
import { TitleService } from '../line/services/title.service';
import { LineHttpInterceptor } from './core/http-setting.interceptor';
import { TrackingIDService } from './services/tracking-id.service';
import { OtpService } from './services/otp.service';
import { LineNotificationService } from './services/line-notification.service';
import { FormReadonlyComponent } from './form-readonly/form-readonly.component';
import { SkyjourneyComponent } from './skyjourney/skyjourney.component';
import { SkymazdaComponent } from './skymazda/skymazda.component';
import { VerifyRegisterComponent } from './verify-register/verify-register.component';
import { DazFormCompleteComponent } from './daz-form-complete/daz-form-complete.component';
import { DazFormComponent } from './daz-form/daz-form.component';
import { DazHistoryComponent } from './daz-history/daz-history.component';
import { DazFormFailComponent } from './daz-form-fail/daz-form-fail.component';
import { VerifyIdentityFormComponent } from './verify-identity-form/verify-identity-form.component';
import { FormFailComponent } from './form-fail/form-fail.component';
import { FormUpdateLineComponent } from './form-update-line/form-update-line.component';
import { ClaimFormComponent } from './claim-form/claim-form.component';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { FormErrorComponent } from './form-error/form-error.component';

@NgModule({ declarations: [
        LineComponent,
        FormComponent,
        ConfirmOtpComponent,
        MobileListComponent,
        CompletedComponent,
        NewUserComponent,
        LoaderComponent,
        TermAndConditionComponent,
        LineConfirmComponent,
        MobileVerifyComponent,
        Route1Component,
        Route2Component,
        Route3Component,
        FormReadonlyComponent,
        SkyjourneyComponent,
        SkymazdaComponent,
        VerifyRegisterComponent,
        DazFormCompleteComponent,
        DazFormComponent,
        DazHistoryComponent,
        DazFormFailComponent,
        VerifyIdentityFormComponent,
        FormFailComponent,
        FormUpdateLineComponent,
        ClaimFormComponent,
        FormErrorComponent
    ],
    imports: [
        CommonModule,
        LineRoutingModule,
        NgOtpInputModule,
        FormsModule,
        ReactiveFormsModule,
        NgxMaskDirective, NgxMaskPipe,
        SharedModule,
        ModalModule], providers: [
        FormVerifyCustomerService,
        ConcentService,
        LoaderService,
        LineStateActionService,
        OtpService,
        TitleService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: LineHttpInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        },
        TrackingIDService,
        LineNotificationService,
        provideHttpClient(withXhr(), withInterceptorsFromDi()),
        provideNgxMask()
    ] })
export class LineModule { }
